/**
 * Sets a timeout that resolves after the given number of milliseconds. Note: if
 * you use this in a test and it doesn't seem to be working, make sure you're not
 * telling Jest to use fake timers!
 *
 * @example
 * jest.useRealTimers();
 * await wait(3000);
 * jest.useFakeTimers();
 */
export function wait(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}
